const isProd = window.location.hostname === "noteddev.objectif.solutions";
export const environment = {
  apiUrl: isProd
    ? "https://noteddevapi.objectif.solutions/api/v1"
    : "http://localhost:8001/api/v1",
};
